<template>
  <SfModalPortal
    :modal-id="'enable-market-package-confirmation-modal'"
    :size="'xs'"
    @opened="handleOpened"
  >
    <template #title>
      {{ props.title }}
    </template>
    <template #body>
      <div v-dompurify-html="renderedText"></div>
      <div class="tw-pt-6 tw-pl-2">
        <ul>
          <li v-for="(packageName, index) in marketPackageNames" :key="index">
            <b>{{ packageName }}</b>
          </li>
        </ul>
      </div>
    </template>
    <template #messages-bottom>
      <SfModalMessage v-if="message" :variant="messageVariant">
        {{ message }}
      </SfModalMessage>
    </template>
    <template #footer>
      <SfButtonDs variant="secondary" @click="handleCancel">{{
        I18n.t('common.form.cancel')
      }}</SfButtonDs>
      <SfButtonDs variant="primary" @click="handleSuccess">
        {{ successButtonText }}
      </SfButtonDs>
    </template>
  </SfModalPortal>
</template>

<script lang="ts" setup>
import {
  SfModalPortal,
  SfModalMessage,
} from '@app/shared/vue/components/sf-modal'
import SfButtonDs from '@app/shared/vue/components/sf-button/sf-button-ds.vue'
import SFetch from '@app/utils/sfetch'
import type { MessageType } from '@app/shared/vue/components/sf-modal/constants'
import type { ModalPortalPayloadMap } from '@app/types'
import { ref } from 'vue'

interface Props {
  title: string
  messageVariant: MessageType
  message: string
  successButtonText: string
}
const I18n = window.I18n
const props = defineProps<Props>()

const entityName = ref('')
const marketPackageNames = ref<Array<string>>([])
const successUrl = ref('')
const submitMethod = ref('GET')
const renderedText = ref('')

const handleOpened = (
  payload: ModalPortalPayloadMap['enable-market-package-confirmation-modal']
) => {
  entityName.value = payload.entityName
  marketPackageNames.value = JSON.parse(payload.marketPackageNames)
  successUrl.value = payload.successUrl
  submitMethod.value = payload.submitMethod
  renderedText.value = I18n.t('market_packages.activation_modal.body', {
    entity_name: entityName.value,
  })
}

const handleCancel = () => {
  window.modalCitizen.closeModalPortal()
}

const handleSuccess = () => {
  window.modalCitizen.closeModalPortal()
  if (submitMethod.value === 'POST' || submitMethod.value === 'PATCH') {
    sendRequest(successUrl.value, submitMethod.value)
  } else {
    window.Turbolinks.visit(successUrl.value)
  }
}

const sendRequest = (url: string, method: string) => {
  SFetch.postFormRedirect({
    url,
    method,
    authenticityToken: window.Silverfin.csrfToken(),
    data: [],
  })
}
</script>
